// <<固定用>>Intersection Observerの設定 -------------
function initializeFooterObserver() {
  const footer = document.getElementById("main-cart-footer");
  const shipping = document.querySelector(".l-cart__shipping");
  const totals = document.querySelector(".l-cart__totals");
  const ctas = document.querySelector(".l-cart__ctas");
  const checkoutCheckDetails = document.querySelector(
    ".checkout-check__details",
  );

  // 要素が見つからない場合は処理をスキップ（カートが空の場合など）
  if (!footer || !shipping || !totals || !ctas) {
    console.log(
      "Required cart footer elements not found, skipping observer setup.",
    );
    // 必要に応じて、staticクラスを削除するなどの初期化処理を追加
    shipping?.classList.remove("static");
    totals?.classList.remove("static");
    ctas?.classList.remove("static");
    return;
  }

  const setFixed = () => {
    shipping.classList.remove("static");
    totals.classList.remove("static");
    ctas.classList.remove("static");
    checkoutCheckDetails.open = false;
  };

  const setStatic = () => {
    shipping.classList.add("static");
    totals.classList.add("static");
    ctas.classList.add("static");
    checkoutCheckDetails.open = true;
  };

  // 既存のObserverインスタンスがあれば切断
  if (window.cartFooterObserverInstance) {
    window.cartFooterObserverInstance.disconnect();
    window.cartFooterObserverInstance = null;
  }

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        setStatic();
      } else {
        setFixed();
      }
    },
    {
      root: null,
      threshold: 0,
    },
  );

  observer.observe(footer);
  window.cartFooterObserverInstance = observer; // 新しいインスタンスを保存

  // 初回ロード時や更新直後の状態を正しく反映させるための初期チェック
  // Intersection Observerは非同期なので、すぐに状態が反映されない可能性があるため
  const rect = footer.getBoundingClientRect();
  if (rect.top < window.innerHeight && rect.bottom > 0) {
    // footerが画面内に一部でも入っているか
    setStatic();
  } else {
    setFixed();
  }
}

// 最初のページロード時にもObserverを初期化するために呼び出す
document.addEventListener("DOMContentLoaded", initializeFooterObserver);
// <<固定用>>Intersection Observerの設定 ------------- //
